import i18n from '@/i18n'

export default (to) => {
  const query = to.query
  if (query.lang) {
    i18n.loadLocale(query.lang)
  }
}
